import { useState } from "react";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import SendOneSMS from "./SendOneSMS";
import SendGroupSMS from "./SendGroupSMS";
import CreateSMS from "./CreateSMS";

export default function SendSMS(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [expanded, setExpanded] = useState("SMS1");
  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/manualsms" }],
      }}
    >
      <SendOneSMS expanded={expanded} setExpanded={setExpanded} />
      <SendGroupSMS expanded={expanded} setExpanded={setExpanded} />
      <CreateSMS expanded={expanded} setExpanded={setExpanded} />
    </Detail>
  );
}
